'use strict';

var cart = require('../cart/cart');
var utils = require('pagedesigner/util/utils');

/**
 * Init minicart events
 */
function initMinicart() {
    var updateMiniCart = true;
    var $body = $(document.body);

    cart.initializeEvents();

    $('.minicart').on('count:update', function (event, count) {
        if (count && !isNaN(count.quantityTotal)) {
            $('.minicart .minicart-quantity').text(count.quantityTotal);
            if (count.quantityTotal > 0) {
                $('.minicart .minicart-quantity').removeClass('visually-hidden');
            } else {
                $('.minicart .minicart-quantity').addClass('visually-hidden');
            }
            $('.minicart .minicart-link').attr({
                'aria-label': count.minicartCountOfItems,
                title: count.minicartCountOfItems
            });
        }
    });

    $('.minicart').on('mouseenter focusin', function (event) {
        if (!utils.mediaBreakpointDown('sm')) {
            event.preventDefault();
            if ($('.search:visible').length === 0) {
                return;
            }
            var url = $('.minicart').data('action-url');
            var count = parseInt($('.minicart .minicart-quantity').text(), 10);

            if (count !== 0 && $('.minicart .popover.show').length === 0) {
                if (!updateMiniCart) {
                    $('.minicart .popover').addClass('show');
                    return;
                }

                $('.minicart .popover').addClass('show');
                $('.minicart .popover').spinner().start();
                $.get(url, function (data) {
                    if (data.numItems < 1 || data.error) {
                        window.location.href = data.cartUrl;
                    } else {
                        $('.minicart .popover').empty();
                        $('.minicart .popover').append(data.renderedTemplate);
                        if ($('.cart-page').length === 0) {
                            updateMiniCart = false;
                        }
                        $.spinner().stop();
                    }
                });
            }
        }
    });

    $('.minicart').on('mouseleave focusout', function (event) {
        if ((event.type === 'focusout' && $('.minicart').has(event.target).length > 0)
            || (event.type === 'mouseleave' && $(event.target).is('.minicart .quantity'))
            || $('body').hasClass('modal-open')) {
            event.stopPropagation();
            return;
        }
        $('.minicart .popover').removeClass('show');
    });

    $body.on('change', '.minicart .quantity', function () {
        if ($(this).parents('.bonus-product-line-item').length && $('.cart-page').length) {
            location.reload();
        }
    });

    $body.on('product:afterAddToCart', function () {
        updateMiniCart = true;
    });

    $body.on('cart:update', function () {
        updateMiniCart = true;
    });

    $body.on('cart:itemRemoved', function () {
        updateMiniCart = true;
        if ($('.minicart .popover.show').length > 0) {
            var url = $('.minicart').data('action-url');
            $.get(url, function (data) {
                $('.minicart .popover').empty().append(data.renderedTemplate);
            });
        }
    });
}

module.exports = {
    init: initMinicart
};
